import { Plan } from "entities/plan";
import { InvoiceLineItemDiscount } from "./invoice_line_item_discount";

export type InvoiceLineItem = {
  amount: number;
  description: string;
  entity_id?: string;
  id: number;
  kind:
    | "subscription"
    | "shopify_product"
    | "shipping_fee"
    | "sc_tea_addon"
    | "unknown";
  plan_id?: Plan["id"];
  quantity: number;
  remote_id: string;
  shopify_product_id?: string;
  shopify_variant_id?: string;
  unit_amount: number;
  discount?: InvoiceLineItemDiscount;
};

export const colorsByKind: Record<InvoiceLineItem["kind"], string> = {
  subscription: "blue",
  shopify_product: "cyan",
  shipping_fee: "yellow",
  sc_tea_addon: "orange",
  unknown: "gray",
};
